
/**
 * @class BlackJackDealBet - information about deal bet.
 */
export class BlackJackDealBet {
    /**
     * @property type - Which hand is bet used for
     */
    hand: number;

    /**
     * @property value - Sum of chips placed on the spot.
     */
    value: number;

    constructor(hand: number, value: number) {
        this.hand = hand;
        this.value = value;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/BlackJackDealBet.ts
 **/